const HotelDetails = ({
  hotelName,
  locationCode,
  timezone,
  address,
  description,
}: {
  hotelName: string;
  locationCode: string;
  timezone: string;
  address: string;
  description: string;
}) => {
  return (
    <div className="w-full md:w-4/12 p-2">
      <div className="bg-white rounded-md p-4">
		<img src="/assets/shared/hotelIcon.svg" className="mt-2 mb-5" alt="hotel" />
        <h4 className="text-base md:text-xl font-medium mb-4">Hotel {hotelName}</h4>
		<div className="my-3">
			<h5 className="text-sm font-normal text-[#5D6679]">Hotel Name</h5>
			<h4 className="text-base font-medium">{hotelName}</h4>
		</div>
		<div className="my-3">
			<h5 className="text-sm font-normal text-[#5D6679]">Location Code (optional)</h5>
			<h4 className="text-base font-medium">{locationCode}</h4>
		</div>
		<div className="my-3">
			<h5 className="text-sm font-normal text-[#5D6679]">Timezone</h5>
			<h4 className="text-base font-medium">{timezone}</h4>
		</div>
		<div className="my-3">
			<h5 className="text-sm font-normal text-[#5D6679]">Address</h5>
			<h4 className="text-base font-medium">{address}</h4>
		</div>
		<div className="my-3">
			<h5 className="text-sm font-normal text-[#5D6679]">Description</h5>
			<h4 className="text-sm font-medium p-2 bg-[#F9F9F9] mt-1">{description}</h4>
		</div>
      </div>
    </div>
  );
};

export default HotelDetails;
